import script from "./HrCardActions.vue?vue&type=script&setup=true&lang=js"
export * from "./HrCardActions.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCardActions});
